import { CoreType, GenericTableSchemaInterface, UserVars, StoreVars } from '../../swivl-lib'
import { BotVariables } from '@swivl/swivl-worksheets-lib'

export const CTA00Table: GenericTableSchemaInterface = {
  id: 'cta-00',
  name: 'CTA 00',
  description:
    'This table contains data regarding how many people engage with the CTA on mobile v desktop.',
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: 'Operator Name',
      variable: BotVariables.Bot_Operator_Name
    },
    c02: {
      name: 'Facility ID',
      variable: StoreVars.StoreId
    },
    c03: {
      name: 'Desktop Start'
    },
    c04: {
      name: 'Mobile Start'
    }
  }
}
